export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6 text-center">
          平台介绍
        </h2>
        <div className="bg-background-50 rounded-2xl p-6 md:p-10">
          <p className="text-foreground-700 leading-relaxed text-base md:text-lg">
            <strong className="text-primary-600">每日大赛mrds</strong>是一个专注<strong className="text-foreground-900">mrds热门话题与每日爆料</strong>的内容聚合平台。我们每日追踪全网最新鲜的"瓜"，第一时间为你揭晓<strong className="text-foreground-900">大赛每日更新</strong>的榜单看点。无论是<strong className="text-foreground-900">mrds榜单揭晓</strong>的黑料深扒，还是让人捧腹的<strong className="text-foreground-900">擦边搞笑</strong>内容，这里都有你想要的精彩。平台以<strong className="text-foreground-900">每日大赛新瓜</strong>为核心，持续刷新你的信息流，让你不再错过任何一个热点。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1.5 rounded-full">
              <i className="ri-fire-line"></i>实时追踪
            </span>
            <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1.5 rounded-full">
              <i className="ri-flashlight-line"></i>每日更新
            </span>
            <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1.5 rounded-full">
              <i className="ri-user-smile-line"></i>万人围观
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}